import React from "react";
import styled from "styled-components";
import { Link, NavLink } from "react-router-dom";
// import { FiArrowRight } from "react-icons/fi";

const Header = ({ toggleMenu }) => {
  return (
    <Wrapper>
      <header>
        {/* ====== Sticky Header ====== */}
        <div
          className="rs-header-area rs-header-one rs-sticky-header"
          id="rs-sticky-header"
        >
          <div className="container-fluid g-0">
            <div className="rs-header-inner">
              <div className="rs-header-left">
                <div className="rs-header-logo-wrapper">
                  <div className="rs-header-logo">
                    <Link to="/">
                      <img
                        src="/assets/images/logo/logo-orange.png"
                        alt="logo"
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="rs-header-menu">
                {/* <div className="rs-theme-social has-transparent has-orange">
                <Link to="#">
                  <i className="ri-twitter-x-line"></i>
                </Link>
                <Link to="#">
                  <i className="ri-facebook-fill"></i>
                </Link>
                <Link to="#">
                  <i className="ri-linkedin-fill"></i>
                </Link>
                <Link to="#">
                  <i className="ri-instagram-line"></i>
                </Link>
              </div> */}
                <nav id="mobile-menu" className="main-menu">
                  <ul className="multipage-menu">
                    <li className="has-mega-menu">
                      <NavLink
                        to="/"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        Home
                      </NavLink>
                    </li>

                    <li className="">
                      <NavLink
                        to="/about"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        About
                      </NavLink>
                    </li>

                    <li className="">
                      <NavLink
                        to="/business-portfolio"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        Business Portfolio
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        to="/csr"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        CSR
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        to="/gallery"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        Gallery
                      </NavLink>
                    </li>

                    <li className="">
                      <NavLink
                        to="/news-media"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        News Media
                      </NavLink>
                    </li>

                    {/* <li className="menu-item-has-children">
                    <Link to="#">Pages</Link>
                    <ul className="submenu last-children">
                      <li className="has-arrow">
                        <Link to="#">Services</Link>
                        <ul className="submenu">
                          <li>
                            <Link to="services">Services</Link>
                          </li>
                          <li>
                            <Link to="services-details">Services Details</Link>
                          </li>
                        </ul>
                      </li>
                      <li className="has-arrow">
                        <Link to="#">Team</Link>
                        <ul className="submenu">
                          <li>
                            <Link to="team">Team</Link>
                          </li>
                          <li>
                            <Link to="team-details">Team Details</Link>
                          </li>
                        </ul>
                      </li>
                      <li className="has-arrow">
                        <Link to="#">Project</Link>
                        <ul className="submenu">
                          <li>
                            <Link to="portfolio">Project</Link>
                          </li>
                          <li>
                            <Link to="portfolio-details">Project Details</Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link to="pricing">Pricing Plan</Link>
                      </li>
                      <li className="has-arrow">
                        <Link to="shop">Shop</Link>
                        <ul className="submenu">
                          <li>
                            <Link to="shop">Product</Link>
                          </li>
                          <li>
                            <Link to="shop-details">Product Details</Link>
                          </li>
                          <li>
                            <Link to="checkout">Checkout</Link>
                          </li>
                          <li>
                            <Link to="cart">Cart</Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link to="faq">Faq</Link>
                      </li>
                      <li>
                        <Link to="appointment">Appointment</Link>
                      </li>
                    </ul>
                  </li> */}

                    {/* <li className="has-mega-menu menu-item-has-children">
                    <Link to="#">Elements</Link>
                    <ul className="mega-menu mega-grid">
                      <li>
                        <Link to="#" className="title">
                          Elements Layout
                        </Link>
                        <ul>
                          <li>
                            <Link to="elements-features">Features</Link>
                          </li>
                          <li>
                            <Link to="elements-advance-tab">Advance Tab</Link>
                          </li>
                          <li>
                            <Link to="elements-work-process">Work Process</Link>
                          </li>
                          <li>
                            <Link to="elements-counter">Counter</Link>
                          </li>
                          <li>
                            <Link to="elements-gsap">GSAP</Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link to="#" className="title">
                          Elements Layout
                        </Link>
                        <ul>
                          <li>
                            <Link to="elements-services">Services Box</Link>
                          </li>
                          <li>
                            <Link to="elements-team">Team</Link>
                          </li>
                          <li>
                            <Link to="elements-pricing">Pricing</Link>
                          </li>
                          <li>
                            <Link to="elements-portfolio">Project</Link>
                          </li>
                          <li>
                            <Link to="#">Coming Soon</Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link to="#" className="title">
                          Elements Layout
                        </Link>
                        <ul>
                          <li>
                            <Link to="elements-services-tab">Services Tab</Link>
                          </li>
                          <li>
                            <Link to="elements-testimonial">Testimonials</Link>
                          </li>
                          <li>
                            <Link to="elements-brand">Partner Logo</Link>
                          </li>
                          <li>
                            <Link to="elements-blog">Blog</Link>
                          </li>
                          <li>
                            <Link to="#">Coming Soon</Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li> */}

                    <li className="">
                      <NavLink
                        to="/contact"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        Contact
                      </NavLink>
                    </li>
                  </ul>
                </nav>
              </div>

              <div className="rs-header-right">
                <div className="rs-theme-social has-transparent has-orange">
                  <Link to="#">
                    <i className="ri-facebook-fill"></i>
                  </Link>
                  <Link to="#">
                    <i className="ri-twitter-x-line"></i>
                  </Link>
                  <Link to="#">
                    <i className="ri-linkedin-fill"></i>
                  </Link>
                  <Link to="#">
                    <i className="ri-instagram-line"></i>
                  </Link>
                </div>

                <div className="rs-header-hamburger">
                  <div className="sidebar-toggle" onClick={toggleMenu}>
                    <Link className="bar-icon" to="#">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                      >
                        <path
                          d="M8.55566 11H1.55566C1.29045 11 1.03609 11.1054 0.848557 11.2929C0.661021 11.4804 0.555664 11.7348 0.555664 12V19C0.555664 19.2652 0.661021 19.5196 0.848557 19.7071C1.03609 19.8946 1.29045 20 1.55566 20H8.55566C8.82088 20 9.07523 19.8946 9.26277 19.7071C9.45031 19.5196 9.55566 19.2652 9.55566 19V12C9.55566 11.7348 9.45031 11.4804 9.26277 11.2929C9.07523 11.1054 8.82088 11 8.55566 11ZM7.55566 18H2.55566V13H7.55566V18ZM19.5557 0H12.5557C12.2904 0 12.0361 0.105357 11.8486 0.292893C11.661 0.48043 11.5557 0.734784 11.5557 1V8C11.5557 8.26522 11.661 8.51957 11.8486 8.70711C12.0361 8.89464 12.2904 9 12.5557 9H19.5557C19.8209 9 20.0752 8.89464 20.2628 8.70711C20.4503 8.51957 20.5557 8.26522 20.5557 8V1C20.5557 0.734784 20.4503 0.48043 20.2628 0.292893C20.0752 0.105357 19.8209 0 19.5557 0ZM18.5557 7H13.5557V2H18.5557V7ZM19.5557 11H12.5557C12.2904 11 12.0361 11.1054 11.8486 11.2929C11.661 11.4804 11.5557 11.7348 11.5557 12V19C11.5557 19.2652 11.661 19.5196 11.8486 19.7071C12.0361 19.8946 12.2904 20 12.5557 20H19.5557C19.8209 20 20.0752 19.8946 20.2628 19.7071C20.4503 19.5196 20.5557 19.2652 20.5557 19V12C20.5557 11.7348 20.4503 11.4804 20.2628 11.2929C20.0752 11.1054 19.8209 11 19.5557 11ZM18.5557 18H13.5557V13H18.5557V18ZM8.55566 0H1.55566C1.29045 0 1.03609 0.105357 0.848557 0.292893C0.661021 0.48043 0.555664 0.734784 0.555664 1V8C0.555664 8.26522 0.661021 8.51957 0.848557 8.70711C1.03609 8.89464 1.29045 9 1.55566 9H8.55566C8.82088 9 9.07523 8.89464 9.26277 8.70711C9.45031 8.51957 9.55566 8.26522 9.55566 8V1C9.55566 0.734784 9.45031 0.48043 9.26277 0.292893C9.07523 0.105357 8.82088 0 8.55566 0ZM7.55566 7H2.55566V2H7.55566V7Z"
                          fill="#616161"
                        ></path>
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ====== Main Header ====== */}
        <div className="rs-header-area rs-header-one">
          <div className="container-fluid g-0">
            <div className="rs-header-inner">
              <div className="rs-header-left">
                <div className="rs-header-logo-wrapper">
                  <div className="rs-header-logo">
                    <Link to="/">
                      <img
                        src="/assets/images/logo/logo-orange.png"
                        alt="logo"
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="rs-header-menu">
                {/* <div className="rs-theme-social has-transparent has-orange">
                <Link to="#">
                  <i className="ri-twitter-x-line"></i>
                </Link>
                <Link to="#">
                  <i className="ri-facebook-fill"></i>
                </Link>
                <Link to="#">
                  <i className="ri-linkedin-fill"></i>
                </Link>
                <Link to="#">
                  <i className="ri-instagram-line"></i>
                </Link>
              </div> */}
                <nav id="mobile-menu-two" className="main-menu">
                  <ul className="multipage-menu">
                    <li className=" ">
                      <NavLink
                        to="/"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        Home
                      </NavLink>
                    </li>

                    <li className="">
                      <NavLink
                        to="/about"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        About
                      </NavLink>
                    </li>

                    <li className="">
                      <NavLink
                        to="/business-portfolio"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        Business Portfolio
                      </NavLink>
                    </li>

                    <li className="">
                      <NavLink
                        to="/csr"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        CSR
                      </NavLink>
                    </li>

                    <li className="">
                      <NavLink
                        to="/gallery"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        Gallery
                      </NavLink>
                    </li>

                    <li className="">
                      <NavLink
                        to="/news-media"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        News Media
                      </NavLink>
                    </li>

                    {/* <li className="menu-item-has-children">
                    <Link to="#">Pages</Link>
                    <ul className="submenu last-children">
                      <li className="has-arrow">
                        <Link to="#">Services</Link>
                        <ul className="submenu">
                          <li>
                            <Link to="services">Services</Link>
                          </li>
                          <li>
                            <Link to="services-details">Services Details</Link>
                          </li>
                        </ul>
                      </li>
                      <li className="has-arrow">
                        <Link to="#">Team</Link>
                        <ul className="submenu">
                          <li>
                            <Link to="team">Team</Link>
                          </li>
                          <li>
                            <Link to="team-details">Team Details</Link>
                          </li>
                        </ul>
                      </li>
                      <li className="has-arrow">
                        <Link to="#">Project</Link>
                        <ul className="submenu">
                          <li>
                            <Link to="portfolio">Project</Link>
                          </li>
                          <li>
                            <Link to="portfolio-details">Project Details</Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link to="pricing">Pricing Plan</Link>
                      </li>
                      <li className="has-arrow">
                        <Link to="shop">Shop</Link>
                        <ul className="submenu">
                          <li>
                            <Link to="shop">Product</Link>
                          </li>
                          <li>
                            <Link to="shop-details">Product Details</Link>
                          </li>
                          <li>
                            <Link to="checkout">Checkout</Link>
                          </li>
                          <li>
                            <Link to="cart">Cart</Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link to="faq">Faq</Link>
                      </li>
                      <li>
                        <Link to="appointment">Appointment</Link>
                      </li>
                    </ul>
                  </li> */}

                    {/* <!-- elements menu --> */}
                    {/* <li className="has-mega-menu menu-item-has-children">
                    <Link to="#">Elements</Link>
                    <ul className="mega-menu mega-grid">
                      <li>
                        <Link to="#" className="title">
                          Elements Layout
                        </Link>
                        <ul>
                          <li>
                            <Link to="elements-features">Features</Link>
                          </li>
                          <li>
                            <Link to="elements-advance-tab">Advance Tab</Link>
                          </li>
                          <li>
                            <Link to="elements-work-process">Work Process</Link>
                          </li>
                          <li>
                            <Link to="elements-counter">Counter</Link>
                          </li>
                          <li>
                            <Link to="elements-gsap">GSAP</Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link to="#" className="title">
                          Elements Layout
                        </Link>
                        <ul>
                          <li>
                            <Link to="elements-services">Services Box</Link>
                          </li>
                          <li>
                            <Link to="elements-team">Team</Link>
                          </li>
                          <li>
                            <Link to="elements-pricing">Pricing</Link>
                          </li>
                          <li>
                            <Link to="elements-portfolio">Project</Link>
                          </li>
                          <li>
                            <Link to="#">Coming Soon</Link>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <Link to="#" className="title">
                          Elements Layout
                        </Link>
                        <ul>
                          <li>
                            <Link to="elements-services-tab">Services Tab</Link>
                          </li>
                          <li>
                            <Link to="elements-testimonial">Testimonials</Link>
                          </li>
                          <li>
                            <Link to="elements-brand">Partner Logo</Link>
                          </li>
                          <li>
                            <Link to="/blog">Blog</Link>
                          </li>
                          <li>
                            <Link to="#">Coming Soon</Link>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li> */}

                    <li className="">
                      <NavLink
                        to="/contact"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        Contact
                      </NavLink>
                    </li>
                  </ul>
                </nav>
              </div>
              <div className="rs-header-right">
                {/* <div className="rs-header-btn">
                <Link
                  className="rs-btn has-theme-orange has-icon has-bg"
                  to="/contact"
                >
                  Get In Touch
                  <span className="icon-box">
                    <svg
                      className="icon-first"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 32 32"
                    >
                      <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                    </svg>
                    <svg
                      className="icon-second"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 32 32"
                    >
                      <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z"></path>
                    </svg>
                  </span>
                </Link>
              </div> */}

                <div className="rs-theme-social has-transparent has-orange">
                  <Link to="#">
                    <i className="ri-facebook-fill"></i>
                  </Link>
                  <Link to="#">
                    <i className="ri-twitter-x-line"></i>
                  </Link>
                  <Link to="#">
                    <i className="ri-linkedin-fill"></i>
                  </Link>
                  <Link to="#">
                    <i className="ri-instagram-line"></i>
                  </Link>
                </div>

                <div className="rs-header-hamburger">
                  <div className="sidebar-toggle" onClick={toggleMenu}>
                    <Link className="bar-icon" to="#">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                      >
                        <path
                          d="M8.55566 11H1.55566C1.29045 11 1.03609 11.1054 0.848557 11.2929C0.661021 11.4804 0.555664 11.7348 0.555664 12V19C0.555664 19.2652 0.661021 19.5196 0.848557 19.7071C1.03609 19.8946 1.29045 20 1.55566 20H8.55566C8.82088 20 9.07523 19.8946 9.26277 19.7071C9.45031 19.5196 9.55566 19.2652 9.55566 19V12C9.55566 11.7348 9.45031 11.4804 9.26277 11.2929C9.07523 11.1054 8.82088 11 8.55566 11ZM7.55566 18H2.55566V13H7.55566V18ZM19.5557 0H12.5557C12.2904 0 12.0361 0.105357 11.8486 0.292893C11.661 0.48043 11.5557 0.734784 11.5557 1V8C11.5557 8.26522 11.661 8.51957 11.8486 8.70711C12.0361 8.89464 12.2904 9 12.5557 9H19.5557C19.8209 9 20.0752 8.89464 20.2628 8.70711C20.4503 8.51957 20.5557 8.26522 20.5557 8V1C20.5557 0.734784 20.4503 0.48043 20.2628 0.292893C20.0752 0.105357 19.8209 0 19.5557 0ZM18.5557 7H13.5557V2H18.5557V7ZM19.5557 11H12.5557C12.2904 11 12.0361 11.1054 11.8486 11.2929C11.661 11.4804 11.5557 11.7348 11.5557 12V19C11.5557 19.2652 11.661 19.5196 11.8486 19.7071C12.0361 19.8946 12.2904 20 12.5557 20H19.5557C19.8209 20 20.0752 19.8946 20.2628 19.7071C20.4503 19.5196 20.5557 19.2652 20.5557 19V12C20.5557 11.7348 20.4503 11.4804 20.2628 11.2929C20.0752 11.1054 19.8209 11 19.5557 11ZM18.5557 18H13.5557V13H18.5557V18ZM8.55566 0H1.55566C1.29045 0 1.03609 0.105357 0.848557 0.292893C0.661021 0.48043 0.555664 0.734784 0.555664 1V8C0.555664 8.26522 0.661021 8.51957 0.848557 8.70711C1.03609 8.89464 1.29045 9 1.55566 9H8.55566C8.82088 9 9.07523 8.89464 9.26277 8.70711C9.45031 8.51957 9.55566 8.26522 9.55566 8V1C9.55566 0.734784 9.45031 0.48043 9.26277 0.292893C9.07523 0.105357 8.82088 0 8.55566 0ZM7.55566 7H2.55566V2H7.55566V7Z"
                          fill="#616161"
                        ></path>
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .rs-header-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 15px;
    margin-left: auto;
  }

  /* 🔥 Active menu color */
  .main-menu a.active {
    color: #ff5c00 !important;
  }

  /* Optional hover effect */
  .main-menu a:hover {
    color: #ff5c00;
  }

  .rs-header-one .main-menu {
    /* border-inline-start: 1px solid rgba(31, 31, 31, 0.07); */
    border-inline-start: none !important;
  }

  /* ===== Desktop (>1024px) ===== */
  @media (min-width: 1025px) {
    .rs-header-hamburger {
      display: none; /* hide hamburger */
    }

    .rs-header-menu {
      display: block; /* show menu */
    }
  }

  /* ===== Tablet + Mobile (≤1024px) ===== */
  @media (max-width: 1024px) {
    .rs-sticky-header .rs-header-menu {
      display: none !important; /* hide menu */
    }

    .rs-sticky-header .rs-header-hamburger {
      display: block !important; /* show hamburger */
    }

    .rs-header-hamburger {
      display: block;
    }
  }
`;

export default Header;
